module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "take-place master-transactions column"
  }, [_c('div', {
    staticClass: "white-box row ctn-transactions-reminder"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "column labels"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n\t  \t\tVous avez "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm.operations.length) + " opération" + _vm._s((_vm.operations.length > 1) ? 's' : ''))])]), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t  \tPour un total encours de "), _c('span', {
    staticClass: "bold"
  }, [_vm._v(_vm._s(_vm._f("moneyFilter")(_vm.computedTotal)) + " €")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "btn btn-red ctn-icon",
    attrs: {
      "to": {
        name: 'MyTransactionsAdd'
      }
    }
  }, [_c('span', {
    staticClass: "icon-button-new-mission"
  }), _vm._v("\n\t\t\tNouvelle opération\n\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\tOpérations d'investissements\n\t")]), _vm._v(" "), _c('keep-alive', [_c('ag-table', {
    attrs: {
      "rows": _vm.computedRows,
      "columns": _vm.cols,
      "customOptions": _vm.options
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ctn-icon"
  }, [_c('span', {
    staticClass: "icon-operations-folder"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cae70a8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions/MyTransactions/Table.vue
// module id = 1127
// module chunks = 0